/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_Engagement_TitleInputs */

const en_landing_preview_engagement_title = /** @type {(inputs: Landing_Preview_Engagement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client engagement`)
};

/**
* | output |
* | --- |
* | "Client engagement" |
*
* @param {Landing_Preview_Engagement_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_engagement_title = /** @type {((inputs?: Landing_Preview_Engagement_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_Engagement_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_engagement_title(inputs)
});